import { Box, Heading, HStack, Text } from '@medely/ui-kit';
import React from 'react';
import { AgencyName } from '@mp/components/agency';

export const AgencyJobCompensation = ({ agencyId }: { agencyId?: number }) => {
  return (
    <Box testId="job-compensation">
      <Heading size="s" color="text.primary" testId="job-compensation-title">
        Compensation
      </Heading>
      <Box pt={2}>
        <HStack gap={1}>
          <Text size="l">Shift will be paid by: </Text>
          <AgencyName agencyId={agencyId} />
        </HStack>
      </Box>
    </Box>
  );
};
